import TargetTaxes from '@domains/target-taxes/views/TargetTaxes.vue'

export default [
  {
    path: 'target-taxes',
    component: TargetTaxes,
    name: 'TargetTaxes',
    props: (route) => ({
      search: route.query.search,
      type: route.query.type,
      expiresAt: route.query.expiresAt,
      status: route.query.status
    })
  }
]
